export default "__VITE_ASSET__CSJ0EaSg__"